import { CloseIcon, SearchIcon } from '@chakra-ui/icons';
import {
  Button, Input, InputGroup,
} from '@chakra-ui/react';
import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';

import { skylineColor } from 'themes/constants';

export function SearchBar(): JSX.Element {
  const [searchParams, setSearchParams] = useSearchParams();

  const [search, setSearch] = useState(() => searchParams.get('search') ?? '');
  const [date, setDate] = useState(() => searchParams.get('date') ?? '');

  const handleSearch = (): void => {
    setSearchParams((prev) => {
      const updatedParams = new URLSearchParams(prev);

      if (search.trim()) updatedParams.set('search', search.trim());
      else updatedParams.delete('search');

      if (date) updatedParams.set('date', date);
      else updatedParams.delete('date');

      return updatedParams;
    });
  };

  const handleClear = (): void => {
    setSearchParams((prev) => {
      const updatedParams = new URLSearchParams(prev);
      updatedParams.delete('search');
      updatedParams.delete('date');
      return updatedParams;
    });
  };

  return (
    <InputGroup gap='2' maxWidth='800px' height='50px'>
      <Input
        type='text'
        value={search}
        placeholder='Search by patient ID, patient name, or owner name...'
        focusBorderColor={skylineColor}
        onChange={(e) => setSearch(e.target.value)}
        onKeyDown={(e) => e.key === 'Enter' && handleSearch()}
      />

      <Input
        type='date'
        maxWidth='170px'
        value={date}
        focusBorderColor={skylineColor}
        onChange={(e) => setDate(e.target.value)}
        onKeyDown={(e) => e.key === 'Enter' && handleSearch()}
      />

      <Button
        leftIcon={<SearchIcon />}
        onClick={handleSearch}
        borderRadius='15px'
        height='55px'
        minW='100px'
        _hover={{ backgroundColor: 'gray.800' }}

      >
        Search
      </Button>

      <Button
        leftIcon={<CloseIcon />}
        onClick={handleClear}
        borderRadius='15px'
        backgroundColor='gray.800'
        height='55px'
        minW='100px'
      >
        Clear
      </Button>
    </InputGroup>
  );
}
